<template>
  <div class="status-breakdown">
    <h3 class="section-title-secondary">BUY BOX STATUS BREAKDOWN</h3>
    <div class="status-cards">
      <div 
        v-for="status in statusData" 
        :key="status.type"
        :class="['status-card', status.type, { active: activeType === status.type }]"
        @click="$emit('status-click', status.type)"
      >
        <div class="status-content">
          <div class="status-icon">
            <i :class="status.icon"></i>
          </div>
          <div class="status-count">{{ status.count }}</div>
          <div class="status-label">{{ status.label }}</div>
          <div class="status-description">{{ status.description }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './styles/StatusBreakdown.css'

export default {
  name: 'StatusBreakdown',
  props: {
    statusData: {
      type: Array,
      required: true
      // Expected structure:
      // [{
      //   type: String ('suppressed', 'lost', 'contested', 'owned'),
      //   icon: String,
      //   count: Number,
      //   label: String,
      //   description: String
      // }]
    },
    activeType: {
      type: String,
      default: ''
    }
  }
}
</script>





// WEBPACK FOOTER //
// StatusBreakdown.vue?588917b2